const SHORTCODE_MAP: Record<string, string> = {
  ":)": "😊", ":-)": "😊", ":D": "😃", ":-D": "😃", "xD": "😆", "XD": "😆",
  ":(": "😞", ":-(": "😞", ":'(": "😢", ":p": "😛", ":P": "😛", ":-p": "😛", ":-P": "😛",
  ";)": "😉", ";-)": "😉", ":o": "😮", ":O": "😮", ":-o": "😮", ":-O": "😮",
  "B)": "😎", "B-)": "😎", ">:(": "😠", ":*": "😘", ":-*": "😘",
  ":/": "😕", ":-/": "😕", ":|": "😐", ":-|": "😐", ":s": "😬", ":S": "😬",
  "^^": "😊", "^_^": "😄", "-_-": "😑", "o_o": "😳", "O_O": "😳", ">_<": "😣", "T_T": "😭",
  "<3": "❤️", "</3": "💔",
  ":fire:": "🔥", ":+1:": "👍", ":-1:": "👎", ":ok:": "👌", ":clap:": "👏",
  ":wave:": "👋", ":pray:": "🙏", ":muscle:": "💪", ":star:": "⭐", ":100:": "💯",
  ":check:": "✅", ":x:": "❌", ":eyes:": "👀", ":thinking:": "🤔", ":skull:": "💀",
  ":rocket:": "🚀", ":party:": "🎉", ":coffee:": "☕", ":pizza:": "🍕", ":beer:": "🍺",
  ":poop:": "💩", ":ghost:": "👻", ":alien:": "👽", ":robot:": "🤖", ":crown:": "👑",
  ":gem:": "💎", ":rainbow:": "🌈", ":sun:": "☀️", ":moon:": "🌙", ":zap:": "⚡",
  ":warning:": "⚠️", ":thumbsup:": "👍", ":thumbsdown:": "👎", ":heart:": "❤️",
  ":lol:": "😂", ":rofl:": "🤣", ":cry:": "😭", ":angry:": "😠", ":cool:": "😎",
  ":wink:": "😉", ":kiss:": "😘", ":hug:": "🤗", ":shrug:": "🤷", ":facepalm:": "🤦",
};

const SORTED = Object.keys(SHORTCODE_MAP).sort((a, b) => b.length - a.length);

// Same regex used by MessageBody for autolinking — kept here as the protection guard
// so a `:/` inside `https://...` never gets translated to 😕.
export const URL_REGEX = /\b(?:https?:\/\/|www\.)[^\s<>"']+/gi;

function replaceShortcodesIn(segment: string): string {
  let result = segment;
  for (const code of SORTED) {
    if (result.includes(code)) {
      result = result.split(code).join(SHORTCODE_MAP[code]);
    }
  }
  return result;
}

export function replaceEmojiShortcodes(text: string): string {
  // Protect URLs : on n'applique les shortcodes que hors-URL.
  // Sinon "https://" → "https😕/" (bug remonté par Julien 2026-06-01).
  let cursor = 0;
  let out = '';
  for (const match of text.matchAll(URL_REGEX)) {
    const start = match.index ?? 0;
    out += replaceShortcodesIn(text.slice(cursor, start));
    out += match[0]; // URL telle quelle
    cursor = start + match[0].length;
  }
  out += replaceShortcodesIn(text.slice(cursor));
  return out;
}
